<template>
  <div :class="{ notUpload: $route.name == 'index'}">
    <el-table
      ref="singleTable"
      v-if="!!height"
      :max-height="height"
      :style="{ width: width, height: height }"
      :data="dataList"
      @selection-change="$emit('selection-change', $event)"
      :class="{ mb8: mb8 }"
      :row-class-name="tableRowClassName"
      :span-method="objectSpanMethod"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column
        v-if="needSelection"
        type="selection"
        width="60"
        :selectable="selectInit"
      >
      </el-table-column>
      <el-table-column
        v-for="item in columns"
        :key="item.id"
        :label="item.label"
        :prop="item.prop"
        :align="align"
        :class-name="item.className"
        :label-class-name="item.labelClassName"
        :min-width="item.width"
        :fixed="item.fix || null"
        :type="item.type || null"
        :filters="item.filters ? filters[item.prop] : null"
        :filter-method="item.filters ? filterMethod : null"
        :sortable="item.sortable ? sortable : false"
        :render-header="getRenderHead(item.renderHeaderType)"
      >
        <template slot-scope="scope">
          <slot
            :name="item.slot"
            :row="scope.row"
            :text="scope.row[scope.column.property]"
            :index="scope.$index"
            v-if="item.slot"
          ></slot>
          <slot
            v-else
            name="cell"
            :row="scope.row"
            :text="scope.row[scope.column.property]"
            :column="scope.column"
            :index="scope.$index"
          ></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-else
      ref="singleTableTwo"
      :style="{ width: width }"
      :data="dataList"
      @selection-change="$emit('selection-change', $event)"
      :class="{ mb8: mb8 }"
      :span-method="objectSpanMethod"
      highlight-current-row
      @current-change="handleCurrentChangeTwo"
    >
      <el-table-column
        v-if="needSelection"
        type="selection"
        width="55"
        :selectable="selectInit"
      >
      </el-table-column>
      <el-table-column
        v-for="item in columns"
        :key="item.id"
        :label="item.label"
        :prop="item.prop"
        :align="align"
        :class-name="item.className"
        :label-class-name="item.labelClassName"
        :min-width="item.width"
        :fixed="item.fix || null"
        :type="item.type || null"
        :filters="item.filters ? filters[item.prop] : null"
        :filter-method="item.filters ? filterMethod : null"
        :sortable="item.sortable ? sortable : false"
        :render-header="getRenderHead(item.renderHeaderType)"
      >
        <template slot-scope="scope">
          <slot
            :name="item.slot"
            :row="scope.row"
            :text="scope.row[scope.column.property]"
            :index="scope.$index"
            v-if="item.slot"
          ></slot>
          <slot
            v-else
            name="cell"
            :row="scope.row"
            :text="scope.row[scope.column.property]"
            :column="scope.column"
            :index="scope.$index"
          ></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 15px; text-align: right"
      v-if="needPagination && bPagination"
      @size-change="handleSizeChange"
      @current-change="handlePageNoChange"
      :current-page="pageNo"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :layout="layout"
      :total="total"
      :background="background"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "wTable",
  components: {},
  props: {
    // 固定表头高度
    height: {
      type: [Number, String],
      default: undefined,
    },
    dataList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 暂时弃用
    bPagination: {
      type: Boolean,
      default: true,
    },
    needSelection: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    pageNo: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50];
      },
    },
    total: {
      type: Number,
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    align: {
      type: String,
      default: "center",
    },
    background: {
      type: Boolean,
      default: true,
    },
    mb8: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
    },
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    renderHeaderBySiteId: {
      type: Function,
    },
    renderHeaderBySiteCeiling: {
      type: Function,
    },
    renderHeaderByRentNum: {
      type: Function,
    },
    renderHeaderByReturnNum: {
      type: Function,
    },
    selectInit: {
      type: Function,
      default() {
        return true;
      },
    },
    objectSpanMethod: {
      type: Function,
    }
  },
  computed: {
    needPagination() {
      return !!this.dataList || (this.dataList && this.dataList.length);
    },
  },
  data() {
    return {
      name: "pageTable",
      filtersArr: [],
      currentRow: null,
      currentRowTwo: null
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.title == "总体情况") {
        return "warning-row";
      }
      return "";
    },
    getRenderHead(type) {
      if (type === "siteId") {
        return this.renderHeaderBySiteId;
      } else if (type === "siteCeiling") {
        return this.renderHeaderBySiteCeiling;
      } else if (type === "rentNum") {
        return this.renderHeaderByRentNum;
      } else if (type === "returnNum") {
        return this.renderHeaderByReturnNum;
      }
      return null;
    },
    filterTag(value, row) {
      console.log(value, row);
    },
    filterMethod(value, row, column) {
      if (value === 1) {
        return this.getSiteStatus(row.num, row.siteBikeCeiling).style === 2;
      } else if (value === 2) {
        return this.getSiteStatus(row.num, row.siteBikeCeiling).style === 3;
      } else if (value === 3) {
        return this.getSiteStatus(row.num, row.siteBikeCeiling).style === 1;
      } else if (value === 4) {
        return this.getSiteStatus(row.num, row.siteBikeCeiling).style === 0;
      }
      return false;
    },
    getSiteStatus(curr, total) {
      const obj = {
        style: "",
        status: "",
      };
      if (curr === 0) {
        obj.style = 0; // 空桩  蓝色icon
        obj.status = "空桩";
      } else if (curr / total < 0.2) {
        obj.style = 1; // 偏少  绿色icon
        obj.status = "偏少";
      } else if (curr / total > 0.8 && curr / total < 1) {
        obj.style = 3; // 偏多  黄色icon
        obj.status = "偏多";
      } else if (curr / total >= 1) {
        obj.style = 2; // 满桩  红色icon
        obj.status = "满桩";
      } else {
        obj.style = 4; // 正常
        obj.status = "正常";
      }
      return obj;
    },
    handleSizeChange(val) {
      this.$emit("pageSizeChange", val);
    },
    handlePageNoChange(val) {
      this.$emit("pageNoChange", val);
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    handleCurrentChangeTwo(val) {
      this.currentRowTwo = val
    },
    setCurrentTwo(val, abnormalData, pageNum) {
      if (this.$refs.singleTable) {
        this.$refs.singleTable.setCurrentRow(val)
      } else {
        const index = abnormalData.findIndex(obj => obj.id === val.id)
        this.$emit('update', pageNum)
        this.$refs.singleTableTwo.setCurrentRow(abnormalData[index])
      }
    }
  }
}
</script>

<style lang="less">
.el-table .warning-row {
  background: #fffeef;
}
// 设置选中当前行的样式
.notUpload .el-table .el-table__body tr.current-row > td {
  color: #fffeef; //字体颜色
  background: #3e7878 !important; //背景颜色
}
//鼠标悬浮样式
.notUpload .el-table .el-table__body tr:hover > td {
  color: #fffeef; //字体颜色
  background: #3e7878 !important; //背景颜色
}
.highlight {
  background-color: yellow;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color:#3e7878
}
</style>
